import { render, staticRenderFns } from "./wizard-card.vue?vue&type=template&id=41797c5e&scoped=true&"
import script from "./wizard-card.vue?vue&type=script&lang=js&"
export * from "./wizard-card.vue?vue&type=script&lang=js&"
import style0 from "./wizard-card.vue?vue&type=style&index=0&id=41797c5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41797c5e",
  null
  
)

export default component.exports